module.exports = __webpack_public_path__ + "img/UKOpenGovernmentLicence.a9da1604.svg";